/**
 * Distinguish Google OAuth failures from app JWT session expiry.
 * Global axios interceptors must NOT logout the user on Google reconnect flows.
 */
export function isGoogleIntegrationAuthError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: Record<string, unknown> }; config?: { url?: string } })
    ?.response;
  if (!response) return false;

  const status = response.status;
  const message = String(
    (response.data?.error as { message?: string } | undefined)?.message ??
      response.data?.detail ??
      ''
  );

  if (
    message.includes('AUTH_EXPIRED') ||
    message.includes('AUTH_REQUIRED') ||
    message.includes('GOOGLE_API_ERROR')
  ) {
    return true;
  }

  if (
    status === 401 &&
    message.includes('AUTH_ERROR') &&
    (message.toLowerCase().includes('google') ||
      message.toLowerCase().includes('token') ||
      message.toLowerCase().includes('reconecta'))
  ) {
    return true;
  }

  const url = String((error as { config?: { url?: string } })?.config?.url ?? '');
  if (
    (status === 401 || status === 403) &&
    (url.includes('google-sheets') ||
      url.includes('google-calendar') ||
      url.includes('/calendar/') ||
      url.includes('google-picker'))
  ) {
    return true;
  }

  return false;
}

export function shouldLogoutOnAuthError(error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status !== 401) return false;
  return !isGoogleIntegrationAuthError(error);
}

export const PAID_SIGNUP_PATH = '/register/paid';

/** 402 = campaign-URL signup that has not paid or verified its email yet. */
export function isPaymentRequiredError(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 402;
}

export function redirectToPaidSignup(): void {
  if (typeof window === 'undefined') return;
  if (window.location.pathname.startsWith(PAID_SIGNUP_PATH)) return;
  window.location.href = PAID_SIGNUP_PATH;
}
